import common from './common.json'
import device from './device.json'
import menu from './menu.json'
import message from './message.json'
import site from './site.json'
import status from './status.json'
import user from './user.json'

export default {
  ...common,
  ...device,
  ...menu,
  ...message,
  ...site,
  ...status,
  ...user,
}
